import { useState } from 'react';
import img1 from '../Components/Images/antennas/am1.png'
import img2 from '../Components/Images/antennas/am2.png'
import img3 from '../Components/Images/antennas/am3.png'
import img4 from '../Components/Images/antennas/am4.png'
import img5 from '../Components/Images/antennas/am5.png'
import './zartecbutton.css'
import './AM_antenna.css'
export default function AM_antenna() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  
  // Sample product data - replace with your actual products
 const products = [
    {
      id: 1,
      name: "MAXUS AM50",
      category: "Premium",
      image: img1,
      alt: "MAXUS AM50 CrossPoint Antenna - Premium AM 58kHz RFID security system with dual antenna technology",
      description: "The MAXUS AM50 combines AM based 58 kHz article surveillance with integrated visitor counting for retail security and loss prevention.",
      details: [
        "Dual antenna technology for comprehensive coverage",
        "Wide 1.8m detection zone for maximum store protection",
        "Compatible with all AM security tags and labels",
        "Energy efficient operation reduces power consumption"
      ],
      rating: 5,
      keywords: "CrossPoint antenna, AM security system, retail anti-theft, RFID detection, MAXUS AM50"
    },
    {
      id: 2,
      name: "PLEXUS AM45",
      category: "Premium",
      image: img2,
      alt: "PLEXUS AM45 Transparent CrossPoint Antenna - Modern retail security system with LED indicators",
      description: "Sleek, transparent PLEXUS AM45 design with powerful RFID detection capabilities. Blends perfectly with modern store aesthetics while providing robust security.",
      details: [
        "Crystal clear acrylic panels for unobtrusive design",
        "LED status indicators for immediate system feedback",
        "Remote management compatible for easy monitoring",
        "Customizable alarm options for different retail environments"
      ],
      rating: 5,
      keywords: "transparent security antenna, AM 58kHz system, PLEXUS AM45, store anti-theft, RFID detection"
    },
    {
      id: 3,
      name: "FORTUS AM40",
      category: "High-End",
      image: img3,
      alt: "FORTUS AM40 CrossPoint Antenna with advertising panel - Retail security and brand promotion",
      description: "Reliable retail protection with stylish advertising space. The FORTUS AM40 maximizes security while promoting your brand at store entrances.",
      details: [
        "Integrated advertising panel for promotions",
        "Digital tag identification for precise detection",
        "Metal-friendly operation in challenging environments",
        "Quick installation process for minimal downtime"
      ],
      rating: 5,
      keywords: "FORTUS AM40 antenna, retail security system, advertising security gates, AM RFID technology"
    },
    {
      id: 4,
      name: "NEXUS AM30",
      category: "High-End",
      image: img4,
      alt: "NEXUS AM30 CrossPoint Security Antenna - Aesthetic store protection with visitor counting",
      description: "NEXUS AM30 systems are aesthetically superior antennas that match store interiors while providing non-obstructive security and visitor analytics.",
      details: [
        "Integrated visitor count for retail analytics",
        "Optional advertising space for promotions",
        "Integrated doorbell for customer service",
        "Jammer detection for enhanced security"
      ],
      rating: 4,
      keywords: "NEXUS AM30 antenna, retail security gates, visitor counting system, AM detection technology"
    },
    {
      id: 5,
      name: "MODUS AM30",
      category: "Mid-Range",
      image: img5,
      alt: "MODUS AM30 CrossPoint Antenna - Cost-efficient retail security solution with jammer detection",
      description: "The MODUS AM30 offers cost-efficient yet solid security solutions with state-of-the-art detection in a robust package for retail environments.",
      details: [
        "Remote service enable for easy maintenance",
        "Compatible with retail analytics systems",
        "Jammer detection for added security",
        "Branding options for store identity"
      ],
      rating: 3,
      keywords: "MODUS AM30 antenna, budget security gates, retail anti-theft system, AM RFID detection"
    }
];

  const handleProductClick = (productId) => {
    setSelectedProduct(productId === selectedProduct ? null : productId);
  };

  return (
    <div className="container ">
      <div className="row product-grid">
        {products.map(product => (
          <div key={product.id} className="">
            {/* col-md-3 mb-4 */}
            <div 
              className={`product-card1 ${selectedProduct === product.id ? 'selected' : ''}`}
              onClick={() => handleProductClick(product.id)}
            >
                {/* card content */}
            
            <div className="card-content1" onClick={() => handleProductClick(product.id)}>  
              {/* Category Badge */}
              <div className="category-badge">{product.category}</div>
              
              {/* Product Name */}
              <h3 className="product-name1">{product.name}</h3>
              
              {/* Product Image */}
              <div className="product-image-container1">
                <img src={product.image} alt={product.alt} className="product-image1" loading="lazy"  />
              </div>
              
              {/* Product Description */}
              <div className="product-description1">
                <p>{product.description}</p>
              </div>
              
              {/* Product Details */}
              <div className="product-details1">
                <h5>Highlights</h5>
                <ul>
                  {product.details.map((detail, index) => (
                    <li key={index}>
                      <span className="detail-bullet">•</span> {detail}
                    </li>
                  ))}
                </ul>
              </div>
              <div className='text-center1'>

                            {[...Array(5)].map((_, index) => (
                <span key={index} style={{ color: index < product.rating ? '#006672' : '#ccc', fontSize: '20px' }}>
                    ★
                </span>
                ))} 
                </div>   
              </div>
              
              {/* Action Button */}
             
              
              <div className='text-center1'>
                <button className='btn zartec-btn zartec-btn-primary zartec-btn-small'>Get Product</button>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* CSS Styling */}
      <style jsx>{`
      .product-grid {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 15px;
      }
`}</style>
    </div>
  );
}

